import ContentStorage from '../../../tnew/content/ContentStorage';

function getValue(name: string) {
  return ContentStorage.getValue('32a0f2f8-6d0e-4f70-bb20-c03b3e9d24ad', name);
}

class FormFieldsComponent {
  static get priceAndQuantityFieldsValidationMessage() {
    return getValue('PriceAndQuantityFieldsValidationMessage');
  }

  static get contributionMinimumValidationMessage() {
    return getValue('ContributionMinimumValidationMessage');
  }

  static get decimalValidationMessage() {
    return getValue('DecimalValidationMessage');
  }

  static get currencyValidationMessage() {
    return getValue('CurrencyValidationMessage');
  }
}

export default FormFieldsComponent;
